module.exports = __webpack_public_path__ + "img/erpNew.55255dc4.png";